<div class="flex flex-col h-full">
  <div class="flex py-2 justify-between">
    <div class="flex w-1/5">
      <elcia-search [control]="filterForm.controls.searchTerm"/>
    </div>
    <elcia-button (onClick)="showForm()" [icon]="'plus'" [label]="'action.add-mail-template' | translate"/>
  </div>

  <div class="flex-1 overflow-hidden">
    <elcia-mail-template-grid
      (onDelete)="deleteMailTemplate($event)"
      (onEdit)="openEditForm($event)"
      [isLoading]="isLoading()"
      [mailTemplates]="mailTemplates()"/>
  </div>
</div>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    [isActionLoading]="isSaving()"
    [mustDisplayDeleteButton]="false"
    [size]="'large'"
    [title]="'entity.mail-template' | translate">
    <elcia-mail-template-form
      (onSubmit)="onFormSubmit($event)"
      [initialValue]="selectedMailTemplate()"/>
  </elcia-dialog>
}

<elcia-confirm-dialog/>
